function clean(rut) {
  return typeof rut === 'string' ? rut.replace(/^0+|[^0-9kK]+/g, '').toUpperCase() : '';
}

function validate(rut) {
  if (typeof rut !== 'string') {
    return false;
  } // if it starts with 0 we return false
  // so a rut like 00000000-0 will not pass


  if (/^0+/.test(rut)) {
    return false;
  }

  if (!/^0*(\d{1,3}(\.?\d{3})*)-?([\dkK])$/.test(rut)) {
    return false;
  }

  rut = clean(rut);
  var t = parseInt(rut.slice(0, -1), 10);
  var m = 0;
  var s = 1;

  while (t > 0) {
    s = (s + t % 10 * (9 - m++ % 6)) % 11;
    t = Math.floor(t / 10);
  }

  var v = s > 0 ? '' + (s - 1) : 'K';
  return v === rut.slice(-1);
}

function format(rut) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    dots: true
  };
  rut = clean(rut);
  var result;

  if (options.dots) {
    result = rut.slice(-4, -1) + '-' + rut.substr(rut.length - 1);

    for (var i = 4; i < rut.length; i += 3) {
      result = rut.slice(-3 - i, -i) + '.' + result;
    }
  } else {
    result = rut.slice(0, -1) + '-' + rut.substr(rut.length - 1);
  }

  return result;
}

function getCheckDigit(input) {
  var rut = Array.from(clean(input), Number);

  if (rut.length === 0 || rut.includes(NaN)) {
    throw new Error("\"".concat(input, "\" as RUT is invalid"));
  }

  var modulus = 11;
  var initialValue = 0;
  var sumResult = rut.reverse().reduce(function (accumulator, currentValue, index) {
    return accumulator + currentValue * (index % 6 + 2);
  }, initialValue);
  var checkDigit = modulus - sumResult % modulus;

  if (checkDigit === 10) {
    return 'K';
  } else if (checkDigit === 11) {
    return '0';
  } else {
    return checkDigit.toString();
  }
}

module.exports = {
  validate: validate,
  clean: clean,
  format: format,
  getCheckDigit: getCheckDigit
};